<div class="c-tooltip__content {{ customClass }}" #tooltip>
    <ng-content></ng-content>
    <div class="c-tooltip__arrow"></div>
</div>